import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { pendingNotificationKey } from "../../../../contexts/NotificationsProvider";
import { SnackbarContext } from "../../../../contexts/Snackbar";
import { acceptAppointment, rejectAppointment, submitAppointment } from "../../../../enums/queryFunction/Submit";
import * as keys from "../../../../enums/QueryKeys";
import useUser from "../../../../hooks/useUser";

export default function usePendingStatus(appointmentID) {
  const { profile, currentClinic } = useUser();
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const queryClient = useQueryClient();

  const acceptFn = async (obj) => {
    setLoading(true);
    accpet(obj);
  };

    const rejectFn = async (obj) => {
    setLoading(true);
    reject(obj);
  };

  function removeFromQuery(queryKey) {
    queryClient.setQueryData([queryKey], (oldData) => {
      if (!oldData) return oldData;
      return oldData.filter(
        (item) => Number(item.id) !== Number(appointmentID)
      );
    });
  }

  function updateKey(key, newData) {
    const updatedEntity = newData;
    queryClient.setQueryData([key], (oldData) => {
      if (!oldData) return oldData; // If no old data, return as is
      if (Array.isArray(oldData)) {
        return oldData.map((entity) =>
          Number(entity.id) === Number(updatedEntity.id)
            ? updatedEntity
            : entity
        );
      } else {
        return updatedEntity;
      }
    });
  }

  const { mutate: accpet } = useMutation({
    mutationFn: (data) => acceptAppointment(data, appointmentID),
    onSuccess: (response) => {
      if (response?.data) {
        [keys.APPOINTMENTS].forEach((key) => updateKey(key, response?.data));
      }
      removeFromQuery(keys.PENDING_APPOINTMENTS, response?.data);
      queryClient.invalidateQueries(keys.APPOINTMENTS);

      //Decrease the number of pending appointments directly from catche
      queryClient.setQueryData(
        [pendingNotificationKey + currentClinic?.id],
        (old) => {
          return typeof old === "number" ? Math.max(0, old - 1) : 0;
        }
      );
      handleSnackbar("successMessage", "success");
      setLoading(false);
    },
    onError: (error) => {
      handleSnackbar("errorMessage", "error");
      setLoading(false);
    },
  });

  const { mutate: reject } = useMutation({
    mutationFn: (data) => rejectAppointment(data, appointmentID),
    onSuccess: (response) => {
      if (response?.data) {
        [keys.APPOINTMENTS].forEach((key) => updateKey(key, response?.data));
      }
      removeFromQuery(keys.PENDING_APPOINTMENTS, response?.data);
      queryClient.invalidateQueries(keys.APPOINTMENTS);
      handleSnackbar("successMessage", "success");
      setLoading(false);
    },
    onError: (error) => {
      handleSnackbar(error, "error");
      setLoading(false);
    },
  });

  return {
    acceptFn,
    rejectFn,
    loading,
  };
}
